//Views
import Launcher from '@/views/Launcher'

const routes = [
    {
        path:'/cliente',
        name: 'launcher',
        component:Launcher,
        meta: {
            title: 'MUCRISIS ༒ Cliente',
            layout: 'launcher',
            metaTags: [
            {
                name: 'description',
                content: 'Página por defecto para el cliente de Mu Crisis.'
            },
            {
                property: 'og:description',
                content: 'Página por defecto para el cliente de Mu Crisis.'
            }
            ]
        }
    },
]

export default routes